import { MenuItem } from "primereact/menuitem";
import { Menubar } from "primereact/menubar";
import "./styles/tabMenuAdmin.css";

function TabMenuAdmin(): JSX.Element {
  const items: MenuItem[] = [
    { label: "Usuarios", icon: "pi pi-users", url: "/admin/users" },
    { label: "Creditos", icon: "pi pi-credit-card", url: "/admin/credits" },
    { label: "Retiros", icon: "pi pi-wallet", url: "/admin/withdrawal" },
    {
      label: "Soporte técnico",
      icon: "pi pi-wrench",
      url: "/admin/technical-support",
    },
    {
      label: "Cerrar sesión",
      icon: "pi pi-sign-out",
      url: "/",
    },
  ];

  return (
    <div className="admin-menu-container">
      <Menubar model={items} className="modern-menubar" />
    </div>
  );
}

export default TabMenuAdmin;